import { render } from "./LandownerChangePassword.vue?vue&type=template&id=c6a07422&scoped=true&ts=true&lang=pug"
import script from "./LandownerChangePassword.vue?vue&type=script&lang=ts&setup=true"
export * from "./LandownerChangePassword.vue?vue&type=script&lang=ts&setup=true"

import "./LandownerChangePassword.vue?vue&type=style&index=0&id=c6a07422&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6a07422"]])

export default __exports__